import type { Route } from '../types';
import { applicationRouteDirectionLabel } from './addressUtils';
import { formatDate } from './applicationDisplayFormat';

/** Единообразно с таблицами заявок / карточками: пусто → «—» */
export const ENTITY_CARD_DASH = '—';

/**
 * Клиент по маршруту: первая заявка с client, иначе route.client.
 * Для карточки «клиент-контрагент» удобнее не вызывать, а подставлять id/имя карточки.
 */
export function primaryClientForRoute(r: Route): { id: number; label: string } | null {
  const apps = r.applications;
  if (Array.isArray(apps)) {
    for (const ra of apps) {
      const cl = ra?.application?.client;
      if (cl?.id != null) {
        const sn = (cl as { shortName?: string | null }).shortName;
        const label = (sn != null && String(sn).trim() !== '' ? String(sn).trim() : cl.name) || ENTITY_CARD_DASH;
        return { id: cl.id, label };
      }
    }
  }
  const rc = r.client;
  if (rc?.id != null) {
    const sn = (rc as { shortName?: string | null }).shortName;
    const label = (sn != null && String(sn).trim() !== '' ? String(sn).trim() : rc.name) || ENTITY_CARD_DASH;
    return { id: rc.id, label };
  }
  return null;
}

/** Подпись направления (город/адрес) */
export function entityCardRouteDirectionLabel(r: Route): string {
  return applicationRouteDirectionLabel({
    loadingCity: r.loadingCity,
    unloadingCity: r.unloadingCity,
    loadingAddress: r.loadingAddress,
    unloadingAddress: r.unloadingAddress
  });
}

/** Погрузка: loadingDate (если есть) → planned → actual */
function routeLoadingDateRaw(r: Route): string | undefined {
  return (r as { loadingDate?: string }).loadingDate ?? r.plannedLoadingDate ?? r.actualLoadingDate;
}

/** Выгрузка: unloadingDate → planned → actual */
function routeUnloadingDateRaw(r: Route): string | undefined {
  return (r as { unloadingDate?: string }).unloadingDate ?? r.plannedUnloadingDate ?? r.actualUnloadingDate;
}

export function entityCardRouteLoadingDate(r: Route): string {
  return formatDate(routeLoadingDateRaw(r) ?? null);
}

export function entityCardRouteUnloadingDate(r: Route): string {
  return formatDate(routeUnloadingDateRaw(r) ?? null);
}
